<template>
  <BaseAlert
    color="text-error"
    :link-text="linkText"
    :href="href"
    data-qa="lpu_reviews_fraud_mark"
  >
    {{ description }}
    <br>
    {{ caution }}
  </BaseAlert>
</template>

<script lang="ts" setup>
import BaseAlert from 'www/vue_components/common/core/BaseAlert.vue'
import useURLStore from 'src/store/useURLStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

const { reverseFull } = useURLStore()

const description = tStatic('Выявлены нарушения со стороны клиники в работе с отзывами. Некоторые отзывы удалены.')
const caution = tStatic('Доверяйте остальным отзывам на этой странице с осторожностью.')
const linkText = tStatic('Подробнее про нарушения')
const href = reverseFull({ name: 'rate_fraud_free' })
</script>
